/* @generated */
function createJoinedObject(source, prefix) {
  return Object.keys(source).reduce(
    (reducer, item) => ({
      ...reducer,
      [`${prefix} ${item}`]: source[item]
    }),
    {}
  );
}
const getKeys = Object.keys;
export {
  createJoinedObject,
  getKeys
};
